//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockControlSpList', {
//        templateUrl: 'views/components/views/stockControlSpList/stockControlSpList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'rememberService', 'logisticService', 'stockControlSpListService', function (stateService, utilityService, rememberService, logisticService, stockControlSpListService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: ''
//            };

//            vm.model = {
//                setting: {},
//                selectListCompanies: [],
//                itemsListControls: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await stockControlSpListService.getSettings())[0];
//            }
            
//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }
            
//            async function loadControls() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;
                
//                vm.model.itemsListControls = [];
                
//                return vm.model.itemsListControls = await stockControlSpListService.listControls({ businessco_no: vm.model.setting.businessco_no });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

//                        rememberFunc('businessco_no');
//                        loadControls();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();
//                loadControls();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
